import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import { Box, IconButton } from "@mui/material";

import { Text } from "../../components/Text";

interface ChatEditPreviewProps {
  message: string;
  onCancel: () => void;
}

/**
 * Display a preview of the message being edited.
 * Shows above the chat input when in edit mode. Mirrors `ChatReplyPreview`.
 */
export function ChatEditPreview(props: ChatEditPreviewProps) {
  const { message, onCancel } = props;

  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        alignItems: "center",
        gap: 2,
        padding: 3,
        backgroundColor: theme.palette.background.default,
        borderLeft: `3px solid ${theme.palette.primary.main}`,
      })}
    >
      <EditIcon
        sx={(theme) => ({
          fontSize: "18px",
          color: theme.palette.primary.main,
        })}
      />

      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Text
          semibold
          variant="caption"
          sx={(theme) => ({
            color: theme.palette.primary.main,
          })}
        >
          Editing message
        </Text>
        <Text
          variant="body2"
          sx={(theme) => ({
            color: theme.palette.text.secondary,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          })}
        >
          {message}
        </Text>
      </Box>

      <IconButton
        aria-label="Cancel edit"
        size="small"
        sx={(theme) => ({
          color: theme.palette.text.secondary,
          "&:hover": {
            color: theme.palette.text.primary,
          },
        })}
        onClick={onCancel}
      >
        <CloseIcon sx={{ fontSize: "18px" }} />
      </IconButton>
    </Box>
  );
}
